import React from 'react';
import Skeleton from 'wsm-skeleton';
import PropTypes from 'prop-types';

export const DetailsSkeletonContainerClasses = ['p-0', 'mt-8'];

const DetailsSkeleton = ({ isTabbedLayout }) => (
	<>
		<div className="row" data-testid="details-skeleton">
			<div className="col-xs-6">
				<div className="skeleton-listing" />
			</div>
			<div className="col-xs-6">
				<div className="skeleton-listing" />
			</div>
		</div>
		{!isTabbedLayout && (
			<Skeleton
				skeletonClasses="ml-auto mt-6"
				width="48%"
				height="3rem"
				dataTestId="price-skeleton"
			/>
		)}
	</>
);

export default DetailsSkeleton;

DetailsSkeleton.propTypes = {
	isTabbedLayout: PropTypes.bool.isRequired
};
